/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useShowError } from "~/components/Error/useShowError";
import { Contact, RouteParams } from "~/models";
import { useAxios } from "~/tools";

const useCustomerContacts = () => {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const state = useParams<RouteParams>();
  const { customerId } = state;

  const { Axios } = useAxios();
  const { showError } = useShowError();

  const fetchContacts = useCallback(async () => {
    try {
      const { data } = await Axios().get(`/customers/${customerId}/contacts`);
      setContacts(data?.externalContacts);
    } catch (e) {
      showError(e.response);
    }
  }, [Axios, showError, customerId, setContacts]);

  useEffect(() => {
    fetchContacts();
  }, [fetchContacts]);

  return { contacts };
};

export { useCustomerContacts };
